import { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Spinner, Checkbox } from "@material-tailwind/react";
import { NewContext } from '../../Context/NewContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import { IoEyeOutline } from 'react-icons/io5';
import { BiEdit } from 'react-icons/bi';
import { get_ai_config } from '../../Controller/actions';
import { Pagination } from './../../Components/Pagination/Pagination';
import THead from '../../Components/Table/THead';
import SearchAndAddBtn from '../../Components/SearchAndAddBtn/SearchAndAddBtn';
import { ConfigModel } from './../../Components/Modals/ConfigModel';


const Config = ({ title }) => {
    useEffect(() => {
        document.title = title;
    }, [title]);

    const { isLoading, setIsLoading, infoData, setDeleteUpdateItem, setDeleteUpdateYes, setAddEditDeleteTag, handleOpen, setFormData, setCurrentPageData, currentPageData, deleteUpdateYes, deleteUpdateTag, perPage, currentPage, totalPage, setCurrentPage, setPerPage, setTotalPage, tokenType, permissions, confirmationModalShow, setConfirmationModalShow, checkedValues, handleCheckboxChange,
    } = useContext(NewContext);
    const simpleFields = [
        { name: "Index", sortable: false, field: 'Index' },
        { name: "API Name", sortable: false, field: 'API Name' },
        { name: "URL", sortable: false, field: 'URL' },
    ];
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });

    const getAiConfigManagerData = async (_currentPage = 1) => {
        setIsLoading(true);
        try {
            const getSurvey = await get_ai_config(_currentPage, perPage);
            if (getSurvey) {
                const { status, data, page, perPage, totalPage } = getSurvey;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(page);
                    setPerPage(perPage);
                    setTotalPage(totalPage);
                } else {
                    setCurrentPageData([]);
                }
                setIsLoading(false);
            } else {
                setCurrentPageData([]);
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        getAiConfigManagerData(currentPage);
    }, [deleteUpdateTag, currentPage, perPage, deleteUpdateYes, pagePermissions]);



    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Config');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])
    const infoFile = Array.isArray(infoData) ? infoData.find(item => item.keyRoute === 'Config')?.infoFile : null;

    useEffect(() => {
    }, [pagePermissions])

    const totalFields = simpleFields.length + 2;

    return (
        <div>
            <SearchAndAddBtn title={`AI Config`} infoFile={`${infoFile}`} isSearch={false} countryFilter={false} perPageCount={true} addBtn={pagePermissions?.CU} deleteUpdateTag='all-delete-config' resetFilterBtn={false} />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <table className="w-full min-w-max table-auto text-left">
                        <THead simpleFields={simpleFields} />
                        <tbody>
                            {
                                isLoading ?
                                    <tr>
                                        <td colSpan={totalFields} className='py-12'>
                                            <div className="flex justify-center items-center">
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                    : currentPageData?.length === 0 ?
                                        <tr>
                                            <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                <div className="flex justify-center items-center">
                                                    No Data Found
                                                </div>
                                            </td>
                                        </tr>
                                        : currentPageData?.map((_ele, i) => {
                                            const isLast = i === currentPageData?.length - 1;
                                            const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                            return (
                                                _ele?.title !== 'isAvatarRandom' &&
                                                <tr key={i} className='border-b border-blue-gray-50 '>

                                                    <td className={classes}>
                                                        <Checkbox
                                                            className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                            id={`slider-${_ele._id}`}
                                                            value={`${_ele._id}`}
                                                            disabled={!pagePermissions?.CU}
                                                            checked={checkedValues.includes(`${_ele._id}`)}
                                                            onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                        />
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center ml-4">
                                                            <span className={'font-normal text-[17px]'}>{i + 1}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center break-words">
                                                            <span className={'font-normal text-[17px]'}>{_ele?.title || `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex items-center break-words">
                                                            <span className={'font-normal text-[17px] truncate break-words w-96'}>{_ele?.description || `None`}</span>
                                                        </div>
                                                    </td>

                                                    <td className={classes}>
                                                        <div className="flex items-center gap-2">
                                                            <IconButton onClick={() => { setDeleteUpdateYes("update-config"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }} disabled={!pagePermissions?.CU} className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none'>
                                                                <BiEdit />
                                                            </IconButton>
                                                            <IconButton onClick={() => { setAddEditDeleteTag(`view`); setFormData(_ele); handleOpen() }} className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' >
                                                                <IoEyeOutline />
                                                            </IconButton>
                                                            <IconButton onClick={() => { setDeleteUpdateYes("delete-config"); setDeleteUpdateItem({ id: _ele._id }); setConfirmationModalShow(!confirmationModalShow) }} disabled={!pagePermissions?.D} className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none'>
                                                                <RiDeleteBinLine />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                            }
                        </tbody>
                    </table>
                </CardBody>
            </Card >
            <Pagination totalPage={totalPage} currentPage={currentPage} getData={getAiConfigManagerData} />
            <ConfigModel />
        </div >
    )
}

Config.defaultProps = {
    title: "Ai Picture Generator | Config"
};

export default Config
